import type RootStore from 'stores/RootStore'

import PageStore from './PageStore'

const initializePage = (rootStore: RootStore) => new PageStore(rootStore)

export type { default as PageStore } from './PageStore'
export default initializePage
